import { render } from "./OuterLayout.vue?vue&type=template&id=8e18440a"
import script from "./OuterLayout.vue?vue&type=script&lang=js"
export * from "./OuterLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__